import { render, staticRenderFns } from "./Richiesta.vue?vue&type=template&id=97b047d6&scoped=true&"
import script from "./Richiesta.vue?vue&type=script&lang=js&"
export * from "./Richiesta.vue?vue&type=script&lang=js&"
import style0 from "./Richiesta.vue?vue&type=style&index=0&id=97b047d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b047d6",
  null
  
)

export default component.exports